import { VerifyIdentity } from "../../components/VerifyIdentity/VerifyIdentity"

export const Verify =()=>{
    return(
        <div>
            <VerifyIdentity />
        </div>
    )
}
